import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import Dropzone from 'dropzone';
import { FilesService } from 'src/app/core/services/files.service';

@Component({
  selector: 'app-upload-image-v1',
  templateUrl: './upload-image.component.html',
  styleUrl: './upload-image.component.scss'
})
export class UploadImageComponent implements OnChanges, AfterViewInit {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) description!: string;
  @Input({ required: false }) preloadUrl?: string;
  @Input({ required: false }) control?: FormControl;
  @Input({ required: true }) url!: string;

  @ViewChild('dropzoneContainer', { static: false }) dropzoneRef!: ElementRef<HTMLDivElement>;


  dropzoneInstance?: Dropzone;

  mockFile: any;

  ngAfterViewInit(): void {
    if (this.dropzoneRef?.nativeElement) {
      this.initDropzone(this.dropzoneRef.nativeElement);
    } else {
      console.error("Dropzone container element not found!");
    }
  }

  constructor(private fileService: FilesService, private toastr: ToastrService,
  ) { }

  private initDropzone(selector: HTMLElement): void {
    this.dropzoneInstance = this.fileService.initDropzone(selector, this.url);
    if (this.preloadUrl) {
      this.loadPreloadedImage(this.preloadUrl);
    }

    if (this.dropzoneInstance) {
      this.dropzoneInstance.on('success', (file: any, response: any) => {
        this.control?.setValue(response.data.fullPathe);
      });

      this.dropzoneInstance.on('removedfile', () => {
        this.control?.setValue(null);
      });
    }
  }

  private loadPreloadedImage(preloadUrl?: string): void {
    if (this.dropzoneInstance) {
      if (this.mockFile) {
        this.dropzoneInstance.emit("removedfile", this.mockFile);
      }

      if (!preloadUrl) {
        return;
      }

      this.mockFile = {
        name: 'Preloaded Image',
        size: 12345,
        type: 'image/jpeg',
      };

      this.dropzoneInstance.emit('addedfile', this.mockFile);
      this.dropzoneInstance.emit('thumbnail', this.mockFile, preloadUrl);
      this.dropzoneInstance.emit('complete', this.mockFile);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['preloadUrl'] && !changes['preloadUrl'].firstChange) {
      this.loadPreloadedImage(this.preloadUrl);
    }
  }
}
